/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('accessWebClient')
    .controller('MultiSelectedNodesActionsController', [
        '$scope', '$modalInstance', 'elements', 'selectionCountSummary', 'multiResultsArray', 'multiResultsModal', 'SyncAndShareNode', 'NodeShareLink', '$q', 'Notarization',
        function ($scope, $modalInstance, elements, selectionCountSummary, multiResultsArray, multiResultsModal, SyncAndShareNode, NodeShareLink, $q, Notarization) {
            $scope.modal = $modalInstance.options;
            $scope.elements = elements;
            $scope.selectionCountSummary = selectionCountSummary;

            switch ($scope.modal.action) {
                case 'restore':
                    var promises = [];
                    $scope.totalFilesCount = 0;
                    $scope.totalFilesSize = 0;
                    $scope.modal.loading = true;
                    angular.forEach($scope.elements, function (element) {
                        promises.push(
                            SyncAndShareNode.getContentsSize({uuid: element.uuid}, function success(data) {
                                $scope.totalFilesCount += data.files_count;
                                $scope.totalFilesSize += data.contents_size;
                            }).$promise
                        );
                    });
                    $q.all(promises).finally(function () {
                        $scope.modal.loading = false;
                    });
                    break;
            }

            $scope.ok = function () {
                var multiResults = [];
                switch ($scope.modal.action) {
                    case 'delete':
                    case 'unsubscribe':
                    case 'unsubscribeDelete':
                        multiResults = multiResultsArray($scope.elements, function (e) {
                            return e.$delete({}).then(_broadcastReloadContentStats);
                        });
                        break;
                    case 'restore':
                        multiResults = multiResultsArray($scope.elements, function (e) {
                            return SyncAndShareNode.restore(e).$promise.then(_broadcastReloadContentStats);
                        });
                        break;
                    case 'notarize':
                        multiResults = multiResultsArray($scope.elements, function(node) {
                            return Notarization.save({node_uuid: node.uuid}).$promise;
                        });
                        break;
                    case 'revokeAll':
                        multiResults = multiResultsArray($scope.elements, function (e) {
                            return NodeShareLink.removeAll({node_uuid: e['uuid']}).$promise;
                        });
                        break;
                    default:
                        $modalInstance.close('ok');
                }
                multiResultsModal(multiResults, selectionCountSummary, $scope.elements[0].constructor, $scope.modal.action).finally(function () {
                    $modalInstance.close('reload_nodes');
                });
            };

            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };

            $scope.close = function () {
                $modalInstance.close('reload_nodes');
            };

            function _broadcastReloadContentStats() {
                $scope.$root.$broadcast('reload.contentStats')
            }
        }]);
